import { NavigateFunction } from "react-router-dom";
import User from "../../../models/user.model";
import { 
    SignupPayloadType, 
    SignupActionType, 
    SignupSuccessPayloadType, 
    SignupSuccessActionType,
    VerifyEmailPayloadType,
    SigninPayloadType,
    Change2FASuccessPayload
} from "./auth.action.types";


export const SIGNUP_START = '[Auth] Signup start';
export const SIGNUP_SUCCESS = '[Auth] Signup success';

export const VERIFY_EMAIL = '[Auth] Verify email';

export const RESEND_VERIFY_EMAIL = '[Auth] Resend verify email';
export const RESEND_SUCCESS = '[Auth] Resend success';

export const SIGNIN_START = '[Auth] Signin start';

export const AUTHENTICATION_SUCCESS = '[Auth] Authentication success';
export const AUTHENTICATION_FAILED = '[Auth] Authentication failed';

export const CHANGE_WALLET = '[Profile] Change Wallet';
export const CHANGE_PASSWORD = '[Profile] Change password';
export const CHANGE_2FA = '[Profile] Change 2FA';
export const CONFIRM_2FA = '[Profile] Confirm 2FA';

export const CHANGE_2FA_SUCCESS = '[Profile] Change 2fA Success';

export const AUTH_UPDATE_SUCCESS = '[Profile] Action success';
export const AUTH_UPDATE_FAILED = '[Profile] Auth update failed';

export const BEFORE_TFA_LOGIN = '[Auth] Before 2FA Login';
export const TFA_FOR_LOGIN = '[Auth] Tfa for login';
export const TFA_FOR_LOGIN_FAILED = '[Auth] Tfa for login failed';

export const AUTO_LOGIN = '[Auth] Auto login';
export const LOGOUT = '[Auth] Log out';
export const LOGOUT_SUCCESS = '[Auth] Log out success';

export const RESET_PASSWORD = '[Auth] Reset password';
export const RESET_PASSWORD_SUCCESS = '[Auth] Reset password success';
export const CONFIRM_RESET_PASSWORD = '[Auth] Confirm reset password';

export const CHANGE_ROLE = '[User] Change Role';
export const CHANGE_ROLE_SUCCESS = '[User] Change role success';
export const CHANGE_ROLE_FAILED = '[User] Change role failed';

export const UPDATE_EXTERNAL_SOURCES = '[User] Update External Sources';
export const UPDATE_EXTERNAL_SOURCES_SUCCESS = '[User] Update External Sources Success';
export const UPDATE_EXTERNAL_SOURCES_FAILED = '[User] Update External Sources Failed';

export const RESET_ERROR= '[AUTH] Reest error';

export type Confirm2FAPayload = {
    token: string;
    code: string;
    method: string;
}

export const ResetErrorMsg = () => {
    return {
        type: RESET_ERROR,
    }
}

export const ChangeWallet = (payload: string) => {
    return {
        type: CHANGE_WALLET,
        payload
    }
}

export const ChangePassword = (payload: {old: string, newPassword: string}) => {
    return {
        type: CHANGE_PASSWORD,
        payload
    }
}

export const Change2FA = (payload: string) => {
    return {
        type: CHANGE_2FA,
        payload
    }
}

export const Confirm2FA = (payload: Confirm2FAPayload) => {
    return {
        type: CONFIRM_2FA,
        payload
    }
}

export const Change2FASuccess = (payload: Change2FASuccessPayload) => {
    return {
        type: CHANGE_2FA_SUCCESS,
        payload
    }
}

export const StartSignup = (payload: SignupPayloadType): SignupActionType => {
    return {
        type: SIGNUP_START,
        payload
    }
}

export const SignupSuccess = (payload: SignupSuccessPayloadType): SignupSuccessActionType => {
    return {
        type: SIGNUP_SUCCESS,
        payload
    }
}

export const VerifyEmail = (payload: VerifyEmailPayloadType) => {
    return {
        type: VERIFY_EMAIL,
        payload
    }
}

export const ResendVerifyEmail = (payload: string) => {
    return {
        type: RESEND_VERIFY_EMAIL,
        payload
    }
}

export const ResendSuccess = (payload: string) => {
    return {
        type: RESEND_SUCCESS,
        payload
    }
}

export const SigninStart = (payload: SigninPayloadType) => {
    return {
        type: SIGNIN_START,
        payload
    }
}

export const AuthUpdateFailed = (payload: any) => {
    return {
        type: AUTH_UPDATE_FAILED,
        payload
    }
}

export const AuthUpdateSuccess = (payload: string) => {
    return {
        type: AUTH_UPDATE_SUCCESS,
        payload
    }
}

export const AuthenticationSuccess = (payload: {user: User, msg: string, token?: string}) => {
    return {
        type: AUTHENTICATION_SUCCESS,
        payload
    }
}

export const AuthenticationFailed = (payload: string) => {
    return {
        type: AUTHENTICATION_FAILED,
        payload
    }
}

export const TfaForLogin = (payload: {
    token: string, 
    code: string,
    navigate: NavigateFunction,
}) => {
    return {
        type: TFA_FOR_LOGIN,
        payload
    }
}

export const TfaForLoginFailed = (payload: string) => {
    return {
        type: TFA_FOR_LOGIN_FAILED,
        payload
    }
}

export const Before2FALogin = (payload: {
    method: string, 
    token: string
}) => {
    return {
        type: BEFORE_TFA_LOGIN,
        payload
    }
}

export const AutoLogin = (payload: {
    accessToken?: string, 
    path?: string,
    navigate?: NavigateFunction
}) => {
    return {
        type: AUTO_LOGIN,
        payload
    }
}

export const LogOut = (payload: NavigateFunction) => {
    return {
        type: LOGOUT,
        payload
    }
}

export const LogoutSuccess = () => {
    return {
        type: LOGOUT_SUCCESS
    }
}

export const ResetPassword = (payload: {navigate: NavigateFunction, email: string}) => {
    return {
        type: RESET_PASSWORD,
        payload
    }
}

export const ResetPasswordSuccess = (payload: {msg: string, token: string}) => {
    return {
        type: RESET_PASSWORD_SUCCESS,
        payload
    }
}

export const ConfirmResetPassword = (payload: {
    navigate: NavigateFunction,
    token: string,
    newPassword: string,
    code: string
}) => {
    return {
        type: CONFIRM_RESET_PASSWORD,
        payload
    }
}

export const ChangeRole = (payload: {role: string, activate: number}) => {
    return {
        type: CHANGE_ROLE,
        payload
    }
}

export const ChangeRoleSuccess = (payload: {user: User, msg: string}) => {
    return {
        type: CHANGE_ROLE_SUCCESS,
        payload
    }
}

export const ChangeRoleFailed = (payload: string) => {
    return {
        type: CHANGE_ROLE_FAILED,
        payload
    }
}

export const UpdateExternalSources = (payload: string[]) => {
    return {
        type: UPDATE_EXTERNAL_SOURCES,
        payload
    }
}

export const UpdateExternalSourcesSuccess = (payload: {user: User, msg: string}) => {
    return {
        type: UPDATE_EXTERNAL_SOURCES_SUCCESS,
        payload
    }
}

export const UpdateExternalSourcesFailed = (payload: string) => {
    return {
        type: UPDATE_EXTERNAL_SOURCES_FAILED,
        payload
    }
}